<template>
    <div>
        <v-card>
            <div>
                <v-card-title>New Listing Promotions
                    <v-spacer></v-spacer>
                    <v-btn v-if="acco_add_hnlp" class="primary" x-small @click="$refs.addHnlp.open(huis_encrid)">add</v-btn>
                    <btn_audit table="hnlp" :encrid="huis_encrid" :size=30
                          tooltip="audit of new listing promotions" />
                </v-card-title>       
                <v-row class="mr-7">
                    <v-col cols="12" class="ml-5 mb-4">
                        <v-simple-table v-if="hnlp.length > 0">
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">
                                    Partner
                                </th>
                                <th class="text-left">
                                    Discount Customer
                                </th>
                                <th class="text-left">
                                    Discount Homeowner
                                </th>
                                <th class="text-left">
                                    Start Date
                                </th>
                                <th class="text-left">
                                    Max. Bookings
                                </th>
                                <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in hnlp"
                                :key="item.hnlp_encrid"
                                >
                                <td>{{ item.hnlp_inpt }}</td>                        
                                <td>{{ item.hnlp_klnt_perc }}</td>
                                <td>{{ item.hnlp_eign_perc }}</td>
                                <td>{{ item.hnlp_start_dat }}</td>
                                <td>{{ item.hnlp_aant_boek }}</td>
                                <td><v-btn text icon v-if="acco_add_hnlp"
                                  @click="deleteHnlp(item.hnlp_encrid)"><v-icon
                                    small>mdi-trash-can-outline</v-icon></v-btn></td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                        <div v-else><small><i>No listing promotions available</i></small></div>
                    </v-col>
                </v-row>             
            </div>
        </v-card>
        <addHnlp ref="addHnlp"></addHnlp>
    </div>
</template>

<script>
    import addHnlp from "@/views/huis/hnlp/addHnlp.vue";
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";
    export default {
        props: {
            huis_encrid: String,
        },     
        mounted(){
            this.getOverview();
        },   
        components: {
            addHnlp,
            btn_audit
        },      
        data() {
            return {
                hnlp: [],
                acco_add_hnlp: false,
            }
        },
        methods: {                    
            getOverview(){
                this.$axios
                    .post("ares/json/ares/huis/hnlp/getHuisHnlp.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHuisHnlp"
                        },
                        getHuisHnlp: {
                            huis_encrid: this.huis_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {                   
                            this.hnlp = res.data.getHuisHnlp.hnlp;   
                            this.acco_add_hnlp = res.data.getHuisHnlp.acco_add_hnlp;      
                        }
                    });   
            }, 
            deleteHnlp(hnlp_encrid){
                this.$axios
                .post("ares/json/ares/huis/hnlp/delHuisHnlp.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "delHuisHnlp"
                    },
                    delHuisHnlp: {
                        hnlp_encrid: hnlp_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {                   
                        this.getOverview();
                    }
                });
            },
            saveHnlp(new_hnlp){
                this.$axios
                .post("ares/json/ares/huis/hnlp/addHuisHnlp.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHuisHnlp"
                    },
                    addHuisHnlp: {
                        huis_encrid: this.huis_encrid,
                        new_hnlp: new_hnlp
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {                   
                        this.getOverview();
                    }
                });
            },
            addHnlp(huis_encrid) {
                this.$refs.addHnlp.open(huis_encrid);
            },
            showDetails() {
                let route = this.$router.resolve({ path: '/task/customer_success/hokl/hokl_overview/huis:' + this.huis_encrid}); 
                window.open(route.href, '_blank');
            }             
        }
    }
</script>

<style scoped>

</style>